<template>
  <div class="write-out">
    <!-- 头部header tab -->
    <header class="header-tabs">
      <div class="tabs">
        <Tab
          :selected="invoiceOpeningInfo.invoiceType"
          isBlueLine
          :tabList="tabList"
          backgroundColor="#fff"
          titleActiveColor="#3378FF"
          titleInactiveColor="#7A8699"
          :handleChange="handleTabChange"
        ></Tab>
      </div>
    </header>
    <!-- 主体内容 -->
    <main class="content">
      <van-field :value="invoiceOpeningInfo.drewDate" label="开票日期" placeholder="自动填入" readonly
      />
      <ModuleHeadText title="发票交付" />
      <van-field :value="invoiceOpeningInfo.purchaserPhone" label="收票人手机号" placeholder="请输入"
        @input="(e) => changeInvoiceOpeningInfo('purchaserPhone', e)"
        @blur="(e) => handleTrim('purchaserPhone', e.target.value)"
      />
      <van-field :value="invoiceOpeningInfo.purchaserEmail" label="收票人邮箱" placeholder="请输入"
        @input="(e) => changeInvoiceOpeningInfo('purchaserEmail', e)"
        @blur="(e) => handleTrim('purchaserEmail', e.target.value)"
      />
      <ModuleHeadText title="购方信息">
        <div class="add-custom" @click="handleAddCustom">
          <i class="huisuiyunfont iconfont">&#xe8fe;</i>
          <span>选择购方</span>
        </div>
      </ModuleHeadText>
      <div class="company-name">
        <van-field
          :value="invoiceOpeningInfo.purchaserName"
          @input="handleChangeCompany($event, 'purchaserName')"
          @blur="(e) => handleTrim('purchaserName', e.target.value)"
          label="购方名称" placeholder="请输入购方名称" />
        <div class="rollup" v-if="companyNameList && companyNameList.length > 0">
          <div
            class="rollup-item"
            v-for="(item, index) in companyNameList"
            @click="handleCompany(item)"
            :key="index"
          >
            <div class="rollup-company">
              <div>{{ item.name }}</div>
              <div v-if="item && item.managementBuyerFlag === 1">已添加</div>
            </div>
          </div>
        </div>
      </div>
      <van-field  :value="invoiceOpeningInfo.purchaserTaxNo" label="购方税号" placeholder="请输入购方税号" @blur="(e) => handleTrim('purchaserTaxNo', e.target.value)" @input="(e) => changeInvoiceOpeningInfo('purchaserTaxNo', e)" />
      <MoreData v-if="invoiceOpeningInfo.invoiceType !== 7 && invoiceOpeningInfo.invoiceType !== 8" :defaultOpen="false">
        <van-field :value="invoiceOpeningInfo.purchaserAddress" label="地址、电话" placeholder="请输入购方地址、电话" @blur="(e) => handleTrim('purchaserAddress', e.target.value)" @input="(e) => changeInvoiceOpeningInfo('purchaserAddress', e)" />
        <van-field :value="invoiceOpeningInfo.purchaserBankName" label="开户行、账号" placeholder="请输入购方开户行、账号"  @blur="(e) => handleTrim('purchaserBankName', e.target.value)" @input="(e) => changeInvoiceOpeningInfo('purchaserBankName', e)" />
        <van-field :value="invoiceOpeningInfo.remark" label="备注" placeholder="请输入备注信息(非必填)" @blur="(e) => handleTrim('remark', e.target.value)"  @input="(e) => changeInvoiceOpeningInfo('remark', e)" />
      </MoreData>
      <van-field v-else :value="invoiceOpeningInfo.remark" label="备注" placeholder="请输入备注信息(非必填)" @blur="(e) => handleTrim('remark', e.target.value)" @input="(e) => changeInvoiceOpeningInfo('remark', e)" />
      <ModuleHeadText title="商品信息" />
      <div class="goods-content">
        <Table
          :handleBtnClick="handleTableBtnClick"
          :tableData="invoiceOpeningInfo.details || []"
          :columns="columns"
          keyField="key"
          isSlide
        >
          <template #td="{ item, field }">
            <div v-if="field === 'taxRate'" class="td">{{ item[field] ? item[field] * 100 + '%' : '' }}</div>
            <div v-else-if="field === 'goodsName'" class="td">{{ `${item['shortName'] ? '*' + item['shortName'].split('*').join() +'*' : ''}${item[field] || ''}` }}</div>
            <div v-else class="td">{{ item[field] === 0 || Number(item[field]) === 0 ? '' :  item[field] }}</div>
          </template>
          <template #bottom="{ row, index }">
            <div v-if="row.discountFlag !== 1" class="edit-goods" @click="() => handleClickEditGood(row, index)">
              <span>编辑商品</span>
            </div>
          </template>
        </Table>
        <div class="add-good-btn">
          <MainButton
            type="default"
            :plain="true"
            :handleClick="handleAddGood"
          >

            <i class="huisuiyunfont iconfont">&#xe8fe;</i>
            <span>添加商品</span>
          </MainButton>
        </div>
      </div>
      <template v-if="invoiceOpeningInfo.invoiceType !== 7 && invoiceOpeningInfo.invoiceType !== 8">
        <van-field :value="invoiceOpeningInfo.payee" label="收款人" placeholder="请输入收款人"
          @input="(e) => changeInvoiceOpeningInfo('payee', e)"
          @blur="(e) => handleTrim('payee', e.target.value)"
        />
        <van-field :value="invoiceOpeningInfo.reviewer" label="复核人" placeholder="请输入复核人"
          @input="(e) => changeInvoiceOpeningInfo('reviewer', e)"
          @blur="(e) => handleTrim('reviewer', e.target.value)"
        />
      </template>
      <van-field :value="invoiceOpeningInfo.drawer" label="开票人" placeholder="请输入开票人"
        :readonly="!(invoiceOpeningInfo.invoiceType !== 7 && invoiceOpeningInfo.invoiceType !== 8)"
        @input="(e) => changeInvoiceOpeningInfo('drawer', e)"
        @blur="(e) => handleTrim('drawer', e.target.value)"
      />
      <ModuleHeadText title="当前销方信息" />
      <van-field v-model="company.name" label="销方名称" placeholder="自动填入" readonly />
      <van-field v-model="company.taxId" label="纳税人识别号" placeholder="自动填入" readonly />
      <template v-if="invoiceOpeningInfo.invoiceType !== 7 && invoiceOpeningInfo.invoiceType !== 8">
        <van-field :value="montageField(company.organzationAddress, company.organzationTel)" label="地址、电话" placeholder="自动填入" readonly />
        <van-field :value="montageField(company.directorBankName, company.directorBankNum)" label="开户行、账号" placeholder="自动填入" readonly />
      </template>
    </main>
    <!-- 底部内容 -->
    <footer>
      <div class="left-money">
        <div>合计含税金额</div>
        <div>￥{{ invoiceOpeningInfo.amountWithTax || '0.00' }}</div>
      </div>
      <div class="preview">
        <MainButton :handleClick="handlePreview">预览</MainButton>
      </div>
    </footer>
    <van-popup v-model="popupShow" round position="bottom" :style="{ height: '60%' }">
      <div class="pop">
        <header class="pop-header">编辑商品</header>
        <section>
          <van-field v-model="editGood.goodsName" label="商品名称" placeholder="请输入商品名称" />
          <van-field v-model="editGood.specification" label="规格型号" placeholder="请输入规格型号" />
          <!-- 含税 -->
          <van-field v-if="editGood.taxSignFlag" v-model="editGood.price" type="number" label="商品单价" placeholder="请输入商品单价"
            @blur="handleEditGood($event, 'price')"
          >
            <template #button>
              <van-checkbox icon-size="18px" v-model="editGood.taxSignFlag" shape="square">含税</van-checkbox>
            </template>
          </van-field>
          <!-- 不含税 -->
          <van-field v-else v-model="editGood.unitPrice" label="商品单价" type="number" placeholder="请输入商品单价"
            @blur="handleEditGood($event, 'unitPrice')"
          >
            <template #button>
              <van-checkbox icon-size="18px" v-model="editGood.taxSignFlag" shape="square">含税</van-checkbox>
            </template>
          </van-field>
          <van-field v-model="editGood.quantity" label="商品数量" type="number" placeholder="请输入商品数量"
            @blur="handleEditGood($event, 'quantity')"
          />
          <van-field :value="editGood.taxRate * 100" label="商品税率%" placeholder="请选择" readonly
            @blur="handleEditGood($event, 'taxRate')"
          />
          <van-field v-model="editGood.discountRate" label="商品折扣%" type="number" placeholder="请输入折扣比例"
            @blur="handleEditGood($event, 'discountRate')"
          />
          <van-field v-if="editGood.taxSignFlag" v-model="editGood.amountWithTax" type="number" label="含税金额" placeholder="请输入含税金额"
            @blur="handleEditGood($event, 'amountWithTax')"
          />
          <van-field v-else v-model="editGood.amount" label="不含税金额" type="number" placeholder="请输入不含税金额"
            @blur="handleEditGood($event, 'amount')"
          />
          <van-field v-model="editGood.taxAmount" label="合计税额" placeholder="自动计算" readonly />
        </section>
        <footer>
          <MainButton
            :handleClick="handleConfirmEdit"
          >
            <span>确认</span>
          </MainButton>
        </footer>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Field, Popup, Checkbox, Notify } from 'vant'
import Observer from '@utils/observer'
import { onCount, uuid, aesDoDecrypt, autoMontageLookUp } from '@utils/basicUtil'
import MoreData from '@/components/MoreData/index.vue'
import { isEmail, isSpecialTicket, aesDoEncrypt } from '@/utils/basicUtil'
import Tab from '@/components/Tab/index.vue'
import { InvoiceCal } from '@/utils/invoiceCal'
import ModuleHeadText from '@/components/ModuleHeadText/index.vue'
import Table from '@/components/Table/index.vue'
import MainButton from '@/components/MainButton/index.vue'
import { mapState, mapActions, mapMutations } from 'vuex'
export default {
  components: {
    Tab,
    Table,
    MoreData,
    MainButton,
    ModuleHeadText,
    [Field.name]: Field,
    [Popup.name]: Popup,
    [Checkbox.name]: Checkbox
  },
  data () {
    return {
      editGood: {},
      tabList: [
        {
          title: '电子普票',
          index: 3
        }, {
          title: '电子专票',
          index: 4
        }, {
          title: '数电普票',
          index: 7
        }, {
          title: '数电专票',
          index: 8
        }
      ],
      popupShow: false,
      columns: [
        { title: '货物或应税劳务', dataIndex: 'goodsName', width: '107px' },
        { title: '含税单价', dataIndex: 'price', width: '69px', align: 'right', type: 'money' },
        { title: '数量', dataIndex: 'quantity', type: 'money' },
        { title: '含税金额', dataIndex: 'amountWithTax', width: '69px', align: 'right', type: 'money' },
        { title: '税率', dataIndex: 'taxRate' }
      ]
    }
  },
  async mounted () {
    Observer.setFunction({
      type: 'changeCompany',
      fn: this.companyChangeRefresh
    })
    Observer.setFunction({
      type: 'changeDept',
      fn: this.onSelectDept
    })
  },
  async activated () {
    // 查询发票开具状态
    await this.getInvoiceResult()
    // 查询全电开票人等信息
    await this.getAllElectricInfo()
    // 开票人同步
    if (!this.invoiceOpeningInfo.drawer) {
      this.resettingDrawer(this.invoiceOpeningInfo.invoiceType)
    }
    // 复制缓存中的goods
    this.copySessionStorageGoods()
    // 选择客户
    if (sessionStorage.customInfo && aesDoDecrypt(sessionStorage.customInfo)) {
      this.handleCompany(aesDoDecrypt(sessionStorage.customInfo))
      sessionStorage.removeItem('customInfo')
    }
    if (this.invoiceResult.status === '0') {
      Notify({ type: 'danger', message: '发票正在开具中...' })
      this.$router.push(`/invoice-opening/result?isOpening=${aesDoEncrypt(true)}`)
    }
    if (this.invoiceResult.status === '2') {
      Notify({ type: 'danger', message: this.invoiceResult.message })
    }
    Observer.setFunction({
      type: 'changeCompany',
      fn: this.companyChangeRefresh
    })
    Observer.setFunction({
      type: 'changeDept',
      fn: this.onSelectDept
    })
  },
  computed: {
    ...mapState('invoiceOpeningModel', ['companyNameList', 'selectGoods', 'goodsLoading', 'loading', 'invoiceResult', 'allElectricInfo']),
    invoiceOpeningInfo () {
      return this.$store.state.invoice.invoiceOpeningInfo
    },
    company () {
      return this.$store.state.user.company
    },
    userInfo () {
      return this.$store.state.user.userInfo
    }
  },
  methods: {
    ...mapActions('invoiceOpeningModel', ['getCompanyList', 'getSelectGoods', 'saveInvoiceInfo', 'getInvoiceResult', 'getAllElectricInfo']),
    ...mapMutations('invoiceOpeningModel', ['setCompanyNameList', 'setSelectGoods']),
    // 复制缓存中的商品
    copySessionStorageGoods () {
      if (sessionStorage.nowGoodsMessage) {
        const goods = Array.isArray(JSON.parse(sessionStorage.nowGoodsMessage)) ? JSON.parse(sessionStorage.nowGoodsMessage).map(i => {
          i.key = uuid()
          return i
        })
          : []
        this.changeInvoiceOpeningInfo('details', goods || [])
        this.calculateTotal()
      }
    },
    // 同步销方信息
    syncSaleInfo () {
      this.changeInvoiceOpeningInfo('sellerName', this.company.name || '')
      this.changeInvoiceOpeningInfo('sellerBankName', this.company.directorBankName || '')
      this.changeInvoiceOpeningInfo('sellerBankAccount', this.company.directorBankNum || '')
      this.changeInvoiceOpeningInfo('sellerTaxNo', this.company.taxId || '')
      this.changeInvoiceOpeningInfo('sellerAddress', this.company.organzationAddress || '')
      this.changeInvoiceOpeningInfo('sellerTel', this.company.organzationTel || '')
    },
    // 选择客户
    handleAddCustom () {
      this.$router.push('/customer/list?isOpening=true')
    },
    // 新增商品
    handleAddGood () {
      this.$router.push('/invoice/goods-list')
    },
    // 点击修改商品按钮
    handleClickEditGood (row, index) {
      this.popupShow = true
      this.editGood = { ...row, index: index, taxSignFlag: true }
    },
    // 修改商品
    handleEditGood (e, field) {
      const index = this.editGood.index
      let value = e.target.value
      this.editGood[field] = value
      let invoiceCal = new InvoiceCal({ data: { ...this.editGood, unitPriceWithTax: this.editGood.price }, invoiceType: this.invoiceOpeningInfo.invoiceType })
      if (field === 'quantity') {
        if (this.editGood.taxSignFlag) { // 当前在含税的这个界面
          invoiceCal.changeQuantityWithTax()
        } else {
          invoiceCal.changeQuantity()
        }
      }
      if (field === 'amountWithTax') {
        invoiceCal.changeAmountWithTax()
      }
      // 含税 price
      if (field === 'price') {
        invoiceCal.changeUnitPriceWithTax()
      }
      // 不含税 unitPrice
      if (field === 'unitPrice') {
        invoiceCal.changeUnitPrice()
      }
      if (field === 'amount') {
        invoiceCal.changeAmount()
      }
      if (field === 'taxRate') {
        if (this.editGood.taxSignFlag) { // 当前在含税的这个界面
          invoiceCal.changeTaxRateWithTax()
        } else {
          invoiceCal.changeTaxRate()
        }
      }
      const goodItem = invoiceCal.getResult()
      this.editGood = { ...goodItem, index, price: goodItem.unitPriceWithTax, unitPrice: goodItem.unitPrice }
    },
    // 计算合计
    calculateTotal () {
      let amount = 0
      let amountWithTax = 0
      let taxAmount = 0;
      (this.invoiceOpeningInfo.details || []).map((item) => {
        item.taxAmount = item.taxAmount || (Number(item.amountWithTax || 0) - Number(item.amount || 0)).toFixed(2)
        amount += Number(item.amount || 0)
        amountWithTax += Number(item.amountWithTax || 0)
        taxAmount += Number(item.taxAmount || 0)
      })
      this.changeInvoiceOpeningInfo('amount', Number(amount).toFixed(2))
      this.changeInvoiceOpeningInfo('amountWithTax', Number(amountWithTax).toFixed(2))
      this.changeInvoiceOpeningInfo('taxAmount', Number(taxAmount).toFixed(2))
    },
    // 去空格
    handleTrim (field, value) {
      let v = value
      if (field === 'purchaserName') {
        setTimeout(() => {
          this.setCompanyNameList([])
        }, 0)
      }
      if ([
        'purchaserPhone',
        'purchaserEmail',
        'purchaserName',
        'purchaserTaxNo',
        'purchaserAddress',
        'purchaserTel',
        'purchaserBankName',
        'purchaserBankAccount',
        'remark',
        'payee',
        'reviewer',
        'drawer'
      ].includes(field)) {
        v = v.toString().trim()
      }
      this.changeInvoiceOpeningInfo(field, v)
    },
    // 预览
    handlePreview () {
      const { details, purchaserEmail, purchaserPhone, invoiceType, purchaserTaxNo, drawer, amountWithTax } = this.invoiceOpeningInfo
      // 是否为清单
      if ((details || []).length > 8) {
        this.changeInvoiceOpeningInfo('listFlag', 1)
      } else {
        this.changeInvoiceOpeningInfo('listFlag', 0)
      }
      // 如果手机号存在
      if (purchaserPhone && purchaserPhone.trim()) {
        const re = /^1[3,4,5,6,7,8,9][0-9]{9}$/
        const result = re.test(purchaserPhone)
        if (!result) {
          return Notify({ type: 'danger', message: '手机号格式不正确' })
        }
      }
      // 如果邮箱存在
      if (purchaserEmail && purchaserEmail.trim()) {
        if (!isEmail(purchaserEmail)) {
          return Notify({ type: 'danger', message: '邮箱格式不正确' })
        }
      }
      let check = ['purchaserName']
      if (invoiceType === 4) { // 电专
        check = ['purchaserName', 'purchaserTaxNo', 'purchaserAddress', 'purchaserBankName']
      }
      if (invoiceType === 8) { // 数电电专
        check = ['purchaserName', 'purchaserTaxNo']
      }
      // 如果找到了不存在的值表示没有填
      if (check.find(field => !this.invoiceOpeningInfo[field])) {
        return Notify({ type: 'danger', message: '请补全购方信息' })
      }
      if (!details || !details.length) {
        return Notify({ type: 'danger', message: '请补全商品信息' })
      }
      if (isSpecialTicket(invoiceType)) { // 专票校验
        if (details.find(i => i.taxRate === 0)) {
          return Notify({ type: 'danger', message: '专票不允许开具免税/零税率发票，请修改税率' })
        }
        if (purchaserTaxNo.trim().length === 0) {
          return Notify({ type: 'danger', message: '请输入购方税号!' })
        } else if (purchaserTaxNo.trim().length !== 0 &&
          !/^[0-9A-Za-z]{9}$/.test(purchaserTaxNo) &&
          !/^[0-9A-Za-z]{15}$/.test(purchaserTaxNo) &&
          !/^[0-9A-Za-z]{17}$/.test(purchaserTaxNo) &&
          !/^[0-9A-Za-z]{18}$/.test(purchaserTaxNo) &&
          !/^[0-9A-Za-z]{19}$/.test(purchaserTaxNo) &&
          !/^[0-9A-Za-z]{20}$/.test(purchaserTaxNo)
        ) {
          return Notify({ type: 'danger', message: '购方税号输入有误' })
        }
      } else { // 普票校验
        if (purchaserTaxNo && (!/^[a-zA-Z0-9]+$/.test(purchaserTaxNo.trim()) || purchaserTaxNo.trim().length > 20)) {
          return Notify({ type: 'danger', message: '税号格式错误仅支持数字/字母，长度小于/等于20位' })
        }
      }
      if (!drawer) {
        return Notify({ type: 'danger', message: '请输入开票人' })
      }
      if (amountWithTax <= 0) {
        return Notify({ type: 'danger', message: '整单金额不能小于或等于0' })
      }
      this.syncSaleInfo()
      // 计算税额 taxAmount
      this.$router.push('/invoice-opening/preview')
    },
    // 添加折扣行
    operateDiscountLine (isAdd = true, discountedLine) {
      if (isAdd) {
        const discountedGood = { ...this.editGood } // 被折扣行
        const discount = this.editGood.discountRate // 折扣率
        discountedGood.fphxz = 2 // 被折扣行当前标识赋值为 2
        discountedGood.discountFlag = 2 // 被折扣行当前标识赋值为 2
        // 折扣行 金额混乱，正常为 amount amountWithTax taxAmount 也存在 money moneyTax tax
        const discountGood = { ...this.editGood }
        discountGood.fphxz = 1
        discountGood.discountFlag = 1
        discountGood.amount = Number(onCount.mul(onCount.mul(discount, 0.01), discountedGood.amount).toFixed(2))
        discountGood.amountWithTax = Number(onCount.mul(onCount.mul(discount, 0.01), discountedGood.amountWithTax).toFixed(2))
        discountGood.taxAmount = Number(onCount.sub(discountGood.amountWithTax, discountGood.amount))

        discountGood.money = discountGood.amount
        discountGood.moneyTax = discountGood.amountWithTax
        discountGood.tax = discountGood.taxAmount
        // 折扣行 格式化一下
        discountGood.amount = discountGood.amount.toFixed(2) || 0
        discountGood.amountWithTax = discountGood.amountWithTax.toFixed(2) || 0
        discountGood.taxAmount = discountGood.taxAmount.toFixed(2) || 0
        discountGood.money = discountGood.money.toFixed(2) || 0
        discountGood.moneyTax = discountGood.moneyTax.toFixed(2) || 0
        discountGood.tax = discountGood.tax.toFixed(2) || 0
        // 被折扣行
        discountedGood.outerDiscountAmount = discountGood.money
        discountedGood.outerDiscountAmountWithTax = discountGood.moneyTax
        discountedGood.outerDiscountTaxAmount = discountGood.tax
        // 折扣行
        discountGood.money = discountGood.money * -1
        discountGood.moneyTax = discountGood.moneyTax * -1
        discountGood.tax = discountGood.tax * -1
        discountGood.amount = discountGood.amount * -1
        discountGood.amountWithTax = discountGood.amountWithTax * -1
        discountGood.taxAmount = discountGood.taxAmount * -1
        discountGood.key = uuid()
        delete discountGood.price
        delete discountGood.quantity
        delete discountGood.unitPrice
        delete discountGood.unitPriceWithTax
        delete discountGood.outerDiscountAmount
        delete discountGood.outerDiscountAmountWithTax
        delete discountGood.outerDiscountTaxAmount
        this.editGood = { ...discountedGood }
        // 拿到商品集合
        const details = this.invoiceOpeningInfo.details || []
        // 当在商品集合中找到了相同的index表示存在折扣行
        const good = details.find(i => i.index === this.editGood.index)
        this.changeDetails(this.editGood.index + 1, discountGood, !good)
      } else {
        const discountedGood = { ...discountedLine }
        discountedGood.fphxz = 0
        discountedGood.discountFlag = 0
        delete discountedGood.outerDiscountAmount
        delete discountedGood.outerDiscountAmountWithTax
        delete discountedGood.outerDiscountTaxAmount
        delete discountedGood.discountRate
        this.changeDetails(discountedGood.index, discountedGood)
      }
    },
    // 确认修改按钮
    handleConfirmEdit () {
      if (!this.editGood.amountWithTax || this.editGood.amountWithTax <= 0) {
        return Notify({ type: 'danger', message: '单条商品含税金额不能为小于等于0' })
      }
      if (this.editGood.discountRate) {
        if (this.editGood.discountRate <= 0 || this.editGood.discountRate > 100) {
          return Notify({ type: 'danger', message: '折扣率必须为百分之0 ~ 100之间' })
        }
        this.operateDiscountLine()
      } else { // 不存在需要看一下是否之前存在折扣行，如果有就需要删除
        const details = this.invoiceOpeningInfo.details || []
        const discountIndex = details.findIndex(i => i.index === this.editGood.index && i.discountFlag === 1)
        if (discountIndex !== -1) {
          this.changeDetails(discountIndex)
        }
      }
      this.changeDetails(this.editGood.index, this.editGood)
      this.popupShow = false
    },
    changeDetails (index, row, isAdd = false) {
      const details = this.invoiceOpeningInfo['details'] || []
      if (row) {
        details.splice(index, isAdd ? 0 : 1, row)
      } else {
        details.splice(index, 1)
      }
      this.changeInvoiceOpeningInfo('details', details)
      sessionStorage.nowGoodsMessage = JSON.stringify(details)
      this.calculateTotal()
    },
    montageField (a, b) {
      return `${a || ''} ${b || ''}`
    },
    handleCompany (item) {
      const { address, bankName, name, taxNo } = autoMontageLookUp(item, this.invoiceOpeningInfo.invoiceType)
      this.changeInvoiceOpeningInfo('purchaserName', name)
      this.changeInvoiceOpeningInfo('purchaserTaxNo', taxNo ? taxNo.toUpperCase() : taxNo)
      this.changeInvoiceOpeningInfo('purchaserAddress', address)
      this.changeInvoiceOpeningInfo('purchaserBankName', bankName)
      this.setCompanyNameList([])
    },
    handleTableBtnClick (type, row, index) {
      if (type === 'del') {
        if (row.discountFlag === 1) { // 删除的是折扣行
          // row.index 是提前存储的记录第几行的标识，折扣行与被折扣行共用
          const details = this.invoiceOpeningInfo.details || []
          const discountedLine = details.find(i => i.index === row.index)
          this.operateDiscountLine(false, discountedLine)
        }
        this.changeDetails(index)
      }
    },
    // 修改InvoiceOpeningInfo
    changeInvoiceOpeningInfo (field, value) {
      this.$store.commit('invoice/changeInvoiceOpeningInfo', { field, value })
    },
    // 重置开票人
    resettingDrawer (v) {
      if ([7, 8].includes(v)) {
        this.changeInvoiceOpeningInfo('drawer', this.allElectricInfo.taxPersonnelName || '')
      } else {
        this.changeInvoiceOpeningInfo('drawer', this.userInfo.trueName || '')
      }
    },
    handleTabChange (v) {
      if (v === this.invoiceOpeningInfo.invoiceType) return
      if ([7, 8].includes(v)) {
        // 是全电需要清空对应的地址电话信息
        this.changeInvoiceOpeningInfo('purchaserAddress', '')
        this.changeInvoiceOpeningInfo('purchaserTel', '')
        this.changeInvoiceOpeningInfo('purchaserBankName', '')
        this.changeInvoiceOpeningInfo('purchaserBankAccount', '')
        this.changeInvoiceOpeningInfo('payee', '')
        this.changeInvoiceOpeningInfo('reviewer', '')
      }
      this.resettingDrawer(v)
      this.changeInvoiceOpeningInfo('invoiceType', v)
    },

    onRefresh () {
      console.log('执行了刷新')
    },
    companyChangeRefresh () {
      if (window.location.pathname + window.location.search === '/invoice-opening/index') {
        this.onRefresh()
      }
    },
    handleChangeCompany (e, field) {
      if (field === 'purchaserName') {
        this.changeInvoiceOpeningInfo('purchaserName', e)
        if (e.length >= 1) {
          // 请求接口
          this.getCompanyList(e)
        }
      }
    },
    onSelectDept (item) {
      const { deptId, deptName } = item
      this.changeApply({
        deptId,
        deptName
      })
      this.$store.commit('invoice/changeDeptInfo', item)
    }
  }
}
</script>

<style lang="less" scoped src="./style.less"/>
